// NOTE: This will let things like http://foo through
// could try to cover ourselves with regex, but ultimately
// we can't guarantee that links are live/stay live so i think its overkill.
export function isValidUrl(input: string): boolean {
  try {
    const url = new URL(input);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
